export default {
  businessType: 'Business Type',
  grDate: 'Date',
  reworkDate: 'Rework Date',
  cartonPe: 'Carton PE',
  asn: 'ASN',
  plant: 'Plant',
  asnNumber: 'ASN#',
  po: 'PO#',
  poItem: 'PO-item#',
  cartonNo: 'Carton No',
  sku: 'SKU (Color+Size)',
  asnQty: 'ASN Qty',
  reworkType: 'Rework Type',
  reworkLt: 'Rework LT',
  relabelUnit: 'Relabel Qty (Unit)',
  noRfidTagQtyUnit: 'No RFID Tag Qty (Unit)',
  scanNoResponseQtyUnit: 'Scan No Response Qty (Unit)',
  multipleRfidCartonQtyUnit: 'Multiple RFID Carton Qty (Unit)',
  physicalSkuCorrectQtyUnit: 'Physical SKU Correct Qty (Unit)',
  physicalSkuIncorrectQtyUnit: 'Physical SKU Incorrect Qty (Unit)',
  productName: 'Product Name',
  singleMultipleUpc: 'Single/Multiple UPC',
  factory: 'Factory',
  lpnSize: 'LPN Size',
  nfcSku: 'NFC SKU',
  wrongPhysicalProduct: 'Wrong Physical Product',
  wrongEpc: 'Wrong EPC',
  multipleEpc: 'Multiple EPC',
  upc: 'UPC',
  skuColor: 'SKU (Color)'
}
